import { render, staticRenderFns } from "./bmi_merchant.vue?vue&type=template&id=a38b4096&scoped=true&"
import script from "./bmi_merchant.vue?vue&type=script&lang=js&"
export * from "./bmi_merchant.vue?vue&type=script&lang=js&"
import style0 from "./bmi_merchant.vue?vue&type=style&index=0&id=a38b4096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38b4096",
  null
  
)

export default component.exports